<template>
  <v-tooltip bottom>
    <v-icon v-if="isRevisadoOk()" small color="green lighten-1" slot="activator">check_circle</v-icon>
    <v-icon v-if="isRevisadoIncompleto()" small color="red lighten-1" slot="activator">error</v-icon>
    <v-icon v-if="isARevisar()" small color="yellow darken-3" slot="activator">pause_circle_filled</v-icon>
    <v-icon v-if="isNoPresentado()" small color="yellow darken-3" slot="activator">edit</v-icon>
    <span>{{ status }}</span>
  </v-tooltip>
</template>

<script>
import Constants from '../../../common/constants'

export default {
  props: {
    status: String
  },

  methods: {
    isRevisadoOk () {
      return this.status === Constants.REVISADO_OK
    },
    isRevisadoIncompleto () {
      return this.status === Constants.REVISADO_INCOMPLETO
    },
    isARevisar () {
      return this.status === Constants.A_REVISAR
    },
    isNoPresentado () {
      return this.status === Constants.NO_PRESENTADO
    }
  }
}
</script>
